import { useCreateHotelPurchase } from 'api-hooks/order/hotel';
import { HotelSaleModel } from 'api-hooks/sale/hotel';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import HotelPurchaseForm from './components/form';
import { HotelPurchaseFormType } from './components/form-type';

export type HotelPurchaseCreateParams = {
  hotelSale?: HotelSaleModel;
  defaultValues?: HotelPurchaseFormType;
};

export default function HotelPurchaseCreate(
  props: NavigationProps<NavigationRoutes.HotelPurchasesCreate>,
) {
  const { mutateAsync, error } = useCreateHotelPurchase();

  const onResolve = useApprovalableEdit('hotel-purchases');

  return (
    <>
      <HotelPurchaseForm
        {...props}
        hotelSale={props.navigation.params?.hotelSale}
        defaultValues={props.navigation.params?.defaultValues}
        renderError={
          !!error &&
          !!error.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => error.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )
        }
        onSubmit={async (input: any, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
